import React from 'react'

const StockReport = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Stock Report</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Reports</li>
            <li className="breadcrumb-item active">Stock Report</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Stock Report</h5>
                <p>Stock report content will be displayed here.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default StockReport

